<script setup lang="ts">
  import { computed, provide } from 'vue';

  import { SpacingDensities } from '../../../types/misc';
  import { TIMELINE_INJECTION } from './keys';

  export interface TimelineProps {
    /**
     * Sets which side of the timeline the main and opposed content is going to be displayed.
     */
    side?: 'start' | 'end';

    /**
     * Sets the size of each timeline item.
     */
    density?: SpacingDensities;
  }

  const props = withDefaults(defineProps<TimelineProps>(), {
    side: 'end',
    density: 'comfortable',
  });

  provide(TIMELINE_INJECTION.key, {
    side: computed(() => props.side),
    density: computed(() => props.density),
  });
</script>

<template>
  <ol
    class="stash-timeline grid grid-flow-dense items-start justify-center gap-x-3 gap-y-1.5"
    :class="[`stash-timeline--${props.side}`, `stash-timeline--${props.density}`]"
    data-test="stash-timeline"
  >
    <slot></slot>
  </ol>
</template>

<style module>
  @layer utilities {
    :global(:where(.stash-timeline)) {
      grid-template-columns: auto min-content auto;
    }
  }
</style>
